import { EquipmentStateBadge } from '@frontend/equipment/badge';
import { EquipmentStateName } from '@frontend/equipment/types';
import { TransactionStateBadge } from '@frontend/transaction/common';
import { TransactionStateName } from '@frontend/transaction/types';
import { UserStateBadge } from '@frontend/user/badge';
import { UserStateName } from '@frontend/user/types';
import React from 'react';

export interface StateBadgeProps {
    state: unknown;
}

export const StateBadge = (props: StateBadgeProps) => {
    if (isInstanceOf(props.state, TransactionStateName)) {
        return <TransactionStateBadge state={props.state as TransactionStateName} />;
    } else if (isInstanceOf(props.state, EquipmentStateName)) {
        return <EquipmentStateBadge state={props.state as EquipmentStateName} />;
    } else if (isInstanceOf(props.state, UserStateName)) {
        return <UserStateBadge state={props.state as UserStateName} />;
    } else {
        return <span>{String(props.state)}</span>;
    }
};

function isInstanceOf(value: unknown, type: object) {
    return Object.values(type).includes(value);
}
